import { useState, useEffect } from "react";
import { Auth, API } from "aws-amplify";
import { logError } from "util/logging";

/**
 * Contains hook to get user bio info, profileId, and passwordAdmin flag.
 *
 * @version 0.0.2
 * @author Steve Hunley
 */
const useProfileId = () => {
  const [profileId, setProfileId] = useState("");
  const [profileEmail, setProfileEmail] = useState("");
  const [profileName, setProfileName] = useState("");
  const [passwordAdmin, setPasswordAdmin] = useState(false); // default false
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchUserAndAdmin = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        if (!user || !user.attributes || !user.attributes.sub) {
          const errorMsg = "useProfileId error: Error getting currentAuthenticatedUser";
          logError(errorMsg, null);
          if (isMounted) setError(errorMsg);
          return;
        }

        if (isMounted) {
          setProfileId(user.attributes.sub);
          setProfileEmail(user.attributes.email);
          setProfileName(user.attributes.name || user.attributes.email);
        }

        // Check password admin status from Account API; keep default=false on any issue
        try {
          const resp = await API.get("AccountGatewayApi", "/user/admin", { withCredentials: true });
          const isAdmin =
            !!resp &&
            (resp.admin === true ||
             resp.admin === "true"); // tolerate string boolean
          if (isMounted) setPasswordAdmin(isAdmin);
        } catch (adminErr) {
          // Do not override default false; just log
          logError("useProfileId /user/admin error", adminErr);
        }
      } catch (err) {
        logError("useProfileId error: Unknown error", err);
        if (isMounted) setError(err);
      }
    };

    fetchUserAndAdmin();
    return () => {
      isMounted = false;
    };
  }, []);

  return { profileId, profileEmail, profileName, passwordAdmin, error };
};

export default useProfileId;
